import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import config, { getHeaders } from "../config";
import { useLanguage } from "../Context/LangContext";
import { loginText as txt } from "../Text";
import banner from "../assets/wap/banner.jpg";
import "./Subscription.scss";
import { Base64 } from "js-base64";
import { SendGuiDataEvents } from "../CommonScript";
import { reactLocalStorage } from "reactjs-localstorage";
import Loader from "../commonComponents/Loader";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import queryString from "query-string";
import SwitchLanguageDropdown from "./SwitchLanguageMenu";

const SubscriptionPage = ({ homeLogo, subUrl }) => {
    console.log(":::::::::SUBSCRIPTION PAGE:::::::::::::::::::")
    const { language } = useLanguage();
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [packs, setPacks] = useState();
    const [title, setTitle] = useState();
    const [subTitle, setSubTitle] = useState();
    const [btnTxt, setBtnTxt] = useState();
    const [isPackSelected, setIsPackSelected] = useState();
    const history = useHistory();
    const msisdn = reactLocalStorage.get("msisdn")
   const camp = sessionStorage.getItem("camp")
   const rcid = sessionStorage.getItem("rcid")

    function handleModal() {
        setShowModal(prev => !prev)
    }
    useEffect(() => {
        let guiDataEvents = {};
        guiDataEvents["page"] = "login";
        guiDataEvents["event"] = "open";
        if (camp) {
            guiDataEvents["camp"] = camp;
            sessionStorage.setItem("camp", camp)
        }
        if (rcid) {
            guiDataEvents["rcid"] = rcid;
            sessionStorage.setItem("rcid", rcid)
        }
        SendGuiDataEvents(guiDataEvents);
    }, []);

    const getPacks = () => {
        let guiEvents = {};
        guiEvents["page"] = "subscription";
        guiEvents["event"] = "getpacks_request";
        SendGuiDataEvents(guiEvents);
        const url = config.get('base') + config.get('getPacks')
        fetch(url,
            {
                method: 'POST',
                headers: { ...getHeaders(), "type" : sessionStorage.getItem('type') }
            })
            .then(res => {
                if (!res.ok) { throw res }
                return res.json()
            })
            .then((res) => {
                let guiEvents = {};
                guiEvents["page"] = "subscription";
                guiEvents["event"] = "getpacks_response";
                guiEvents["status"] = res.status;
                guiEvents["pack"] = packs;
                SendGuiDataEvents(guiEvents);

                reactLocalStorage.set(res.status, "success");
                if (res.status === 'success') {
                    console.log("res>>>>>>>>>", res.pack_type)
                    setPacks(res?.pack_type)
                    setTitle(res?.title)
                    setSubTitle(res?.subtitle)
                    setBtnTxt(res?.btn_txt)
                    setLoading(false)
                } else {
                }
            }).catch((err) => {
                setLoading(false)
                console.log(err)
            })
    }

    const checkSub = () => {
        let guiDataEvents = {};
        guiDataEvents["page"] = "login";
        guiDataEvents["event"] = "checksub_request";
        guiDataEvents["msisdn"] = msisdn;
        SendGuiDataEvents(guiDataEvents);
        setLoading(true)
        const url = `${config.get('base')}${config.get('checkSub')}`;
        const headers = {
            ...getHeaders(),
            Language: language
        }
        console.log('::::::::MSISDN IN SUBSCRIPTION PAGE:::::::::::', msisdn)
        fetch(url, {
            method: 'POST',
            body: JSON.stringify({ 'msisdn': msisdn }),
            headers: headers
        })
            .then(res => {
                if (!res.ok) { throw res }
                return res.json()
            })
            .then((result) => {
                console.log('result message::', result);
                let guiDataEvents = {};
                guiDataEvents["page"] = "login";
                guiDataEvents["event"] = "checksub_response";
                guiDataEvents["msisdn"] = msisdn;
                guiDataEvents["status"] = result?.subStatus;
                SendGuiDataEvents(guiDataEvents);
                reactLocalStorage.set("msisdn", result?.msisdn)
                reactLocalStorage.set("subStatus", result?.subStatus?.toUpperCase())
                if (result?.status === 'success') {
                    if (result?.subStatus === "active") {
                        setLoading(false);
                        console.log("user is active")
                        reactLocalStorage.set("status", result?.subStatus)
                        reactLocalStorage.set("msisdn", result?.msisdn)
                        reactLocalStorage.set("status_display", result?.status_display)
                        reactLocalStorage.set('lastCheckSubTime', new Date().getTime());
                        reactLocalStorage.set("uid", result?.uid);
                        history.push("/home")
                    }
                    else if (result?.subStatus === "new") {
                        reactLocalStorage.set('initStatus', 'new');
                        getPacks()
                        // window.open(redirect_url, "_self");
                    }
                    else {
                        setLoading(false);
                        const messages = [
                            result?.message,
                            result?.message1,
                            result?.message2,
                            result?.message3
                        ];
                        const encodedMessages = messages.map(msg => Base64.encode(msg)).join(',');
                        history.push(`/thanks?msgs=${encodedMessages}`)
                    }
                    reactLocalStorage.set("planType", result?.subType);
                    reactLocalStorage.set("validity", result?.validity);
                }
                else {
                    setLoading(false)
                    reactLocalStorage.set("checkStatus", result?.status?.toUpperCase())
                    history.push(`/thanks?msg=${Base64.encode(result?.message)}`)
                }
            },
                (error) => {
                    console.log('error:::', error)
                    history.push("/thanks");
                    setLoading(false);
                })
    }

    useEffect(() => {
        if(camp === "C2COFRLOCPA"){
            setLoading(true)
            window.open(subUrl, "_self")
        }
        if (msisdn) {
            checkSub()
        }
        else {
            getPacks()
        }
        
    }, [])

    const handleSubRedirection = () => {
        console.log("::::::::::redirect url:::::::;", subUrl)
        window.open(subUrl, "_self")
    }

    if (loading) return <Loader />;

    return (
        <>
            {/* <SwitchLanguageDropdown homeLogo={homeLogo} /> */}
            <div className="">
                {homeLogo && <img src={homeLogo} alt="logo" className="my-3" height="70px" width="70px" />}
                <div className="main-container">
                    <img src={banner} alt="enter msisdn" className="" />
                    <h1 className="my-4 text-white font-bold text-lg text-start px-5">{title}</h1>
                    <div className="px-5">
                        <div className={`pack-details flex flex-col ${isPackSelected ? 'pack-selected-bg' : ''}`}
                            onClick={() => setIsPackSelected(!isPackSelected)}
                        >
                            {
                                packs && packs.map((pack) => (
                                    <>
                                        <div className="pack-name-details">
                                            <div className="font-bold text-lg">{pack.price}</div>
                                            <div className="text-sm">{subTitle}</div>
                                        </div>
                                        <div className="pack-price-details font-bold text-lg">
                                            {pack.pp}
                                        </div>
                                    </>
                                ))
                            }
                        </div>
                        <button className="subscription-button btn w-full text-white font-bold my-5" onClick={() => handleSubRedirection()}>
                            {btnTxt}
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SubscriptionPage;